<template>
  <a-row :gutter="8" :class="getScreen ? 'm-list-wrapper' : 'd-list-wrapper'">
    <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
      <a-card :loading="loading">
        <div slot="title"><a-icon type="file-search" />&nbsp; Search</div>
        <ul class="m-list-wrapper">
          <li>
            <a-input-search v-model="search" placeholder="Quick Search" />
          </li>
          <li>
            <a-collapse activeKey="1">
              <a-collapse-panel key="1">
                <span slot="header">Search More...</span>
                <div class="m-form-item-wrapper">
                  <label for="tanggalTransaksi">Transaction Date</label>
                  <a-date-picker
                    placeholder="Select Date"
                    v-model="searchDate"
                    @change="searching"
                    format="DD-MM-YYYY"
                    allowClear
                  />
                </div>
                <div class="m-form-item-wrapper">
                  <label for="tanggalTransaksi">Status</label>
                  <a-select
                    placeholder="Ex: Approved ... "
                    v-model="status"
                    @change="searching"
                    class="width-full"
                    initialValue="delivered"
                    allowClear
                  >
                    <a-select-option
                      v-for="item in getStatus"
                      :key="item.id"
                      :value="item.value"
                      >{{ item.label }}</a-select-option
                    >
                  </a-select>
                </div>
                <div class="m-form-item-wrapper">
                  <label for="department">Department</label>
                  <a-select
                    placeholder="Select Department"
                    v-model="department"
                    @change="searching"
                    class="width-full"
                    :initialValue="null"
                    allowClear
                  >
                    <a-select-option
                      v-for="item in departmentList"
                      :key="item.id_dept"
                      :value="item.id_dept"
                      >{{ item.nama_dept }}</a-select-option
                    >
                  </a-select>
                </div>
              </a-collapse-panel>
            </a-collapse>
          </li>
        </ul>
      </a-card>
    </a-col>
    <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
      <DataList
        :loading="loading"
        title="Prospect Notification List"
        createLink="createProspectNotification"
        :manifestLink="getManifest"
        editLink="editProspectNotification"
        :dataList="dataListOutput"
        :estimasi="true"
        :isTransactional="true"
        :disabledCreateEditLink="!isMarketing"
        :allowcancel="false"
      />
    </a-col>
  </a-row>
</template>

<script>
import { mapGetters } from "vuex";
import Axios from "axios";
import moment from "moment";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import Status from "@/components/Status.vue";
import Rating from "@/components/Rating.vue";

export default {
  name: "RnDNotification",
  mixins:[CurrencyFormat],
  components: {
    Status,
    Rating,
  },
  data() {
    return {
      loading: true,
      rndNotifList: [],
      storeList: [],
      search: "",
      searchDate: null,
      status: undefined,
      department: undefined,
      departmentList: [],
      kategori: "",
      pagination: {
        pageSize: 5,
        size: "small",
      },
    };
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getSalesType",
      "getStatus",
      "getDefaultDateFormat",
    ]),
    dataListOutput() {
      let output = [];

      this.rndNotifList.forEach((data) => {
        output.push({
          title: data.no_prospek,
          subdesc: [
             moment(data.create_dt).format(this.getDefaultDateFormat) +
              " | " +
              data.tlc_create,
            [
              {
                label: "Description",
                value: data.description,
              },
              {
                label: "Customer",
                value: data.customer,
              },
              {
                label: "Est. Sales",
                value: this.formatCurrency("IDR", data.est_nilai_penjualan),
              },
              {
                label: "Est. Prospect",
                value: this.formatCurrency("IDR", data.est_biaya_prospek),
              },
            ],
          ],
          status: data.status,
          cancelStatus: data.cancel_sts
            ? data.cancel_sts == 1
              ? "Canceled"
              : data.cancel_sts == 2
              ? "Unusual"
              : null
            : null,
          dis_rev: data.tlc_create==this.getAuth.username?false:true,
          id: data.id_prospek,
          timeline: JSON.parse(data.status_app),
          islistPPrevised: false,
        });
      });

      return output;
    },
    searching() {
      // let filteredDataBySearch = [];
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.rndNotifList = this.storeList;

      if (this.search) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.rndNotifList = this.rndNotifList.filter(
          (obj) =>
            obj.no_prospek
              .concat(obj.tlc_create)
              .concat(obj.customer)
              .concat(obj.description ? obj.description : "-")
              .concat(moment(obj.create_dt).format(this.getDefaultDateFormat))
              .concat(this.formatCurrency("IDR", obj.est_nilai_penjualan))
              .concat(this.formatCurrency("IDR", obj.est_biaya_prospek))
              .toLowerCase()
              .indexOf(this.search.toLowerCase()) >= 0
        );
      }

      if (this.kategori) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.rndNotifList = this.rndNotifList.filter(
          (obj) =>
            obj.kategori &&
            obj.kategori.toLowerCase().indexOf(this.kategori.toLowerCase()) >= 0
        );
      }

      if (this.status) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.rndNotifList = this.rndNotifList.filter(
          (obj) =>
            obj.status &&
            obj.status.toLowerCase().indexOf(this.status.toLowerCase()) >= 0
        );
      }

      if (this.searchDate) {
        let searchDate = moment(this.searchDate).format("YYYY-MM-DD");
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.rndNotifList = this.rndNotifList.filter((obj) => moment(obj.create_dt).format("YYYY-MM-DD") == searchDate);
      }

      if (this.department) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.rndNotifList = this.rndNotifList.filter(
          (obj) =>
            obj.id_dept &&
            obj.id_dept.toLowerCase().indexOf(this.department.toLowerCase()) >= 0
        );
      }

      if (!this.kategori && !this.search && !this.status && !this.department && !this.searchDate) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.rndNotifList = this.storeList;
      }
      return true
    },
    isAtasanLangsung() {
      if(localStorage.getItem("nvky") == "54")
        return true
      return false;
    },
    isAkuntansi(){
      let res = false
      this.getAuth.divisi.forEach(element => {
        if(element.toLowerCase()=='akuntansi' 
        || element.toLowerCase()=='corporate' 
        || element.toLowerCase()=='keuangan' 
        || element.toLowerCase()=='financial control'
        || element.toLowerCase()=='chief technology officer' 
        || element.toLowerCase()=='vice president marketing' 
        || element.toLowerCase()=='chief operation officer' 
      ){
          res = true
        }
      });
      return res
    },
    isMarketing(){
      let res = false
      this.getAuth.divisi.forEach(element => {
        if(element.toLowerCase()=='marketing' || element.toLowerCase()=='international business development'
      ){
          res = true
        }
      });
      return res
    },
    getManifest(){
      let res = "manifestProspectNotification"
      if(this.$route.path.includes('/direktur/')){
        res = "manifestProspectNotificationDir"
      } else if(this.$route.path.includes('/financialControl/')){
        res = "manifestProspectNotificationFC"
      } else if(this.$route.path.includes('/akuntansiKeuangan/')){
        res = "manifestProspectNotificationACC"
      } else if(this.$route.path.includes('/programme/')){
        res = "manifestProspectNotificationProg"
      }
      //else if(this.$route.path.includes('/direktur/')){
      //   res = "manifestRNDNotificationDir"
      // }else if(this.$route.path.includes('/keuangan/')){
      //   res = "manifestRNDNotificationKeu"
      // }
      return res
    }
  },
  methods: {
    moment,
    fetchrndNotification() {
      let param = {
        tlc: this.getAuth.username,
      }

      if(this.isAkuntansi)
        param['id'] = localStorage.getItem("nvky")

      Axios({
        method: "get",
        // url: this.$serviceUrl + (this.isAkuntansi ? "monitoring/prospek":"prospek"),
        url: this.$serviceUrl + "prospek",
        params: param,
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.rndNotifList = response.data.data;
          this.storeList = response.data.data;
          this.departmentList = response.data.dept;
          this.loading = false;
        })
        .catch((err) => {
          if (!error.response) {
            this.displayMessage("error-connection-refused");
          } else {
            this.loading = false;
            this.displayMessage("empty-db");
          }
        });
    },
    canceltrans(item) {
      Axios({
        method: "post",
        url: this.$serviceUrl + "main/cancel_transaction",
        params: {
          tlc: this.getAuth.username,
        },
        data: {
          tlc: this.getAuth.username,
          jenis_trans: "salesnotif",
          id_manifest: item.id,
          code_trans: item.title,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.displayMessageValue("successCancel", response.data.message);
          //this.fetchData();
          this.$router.go();
          //this.searching;
        })
        .catch((err) => {
          if (!err.response) {
            this.displayMessage("error-connection-refused");
          } else {
            this.loading = false;
            this.displayMessage("empty-db");
          }
        });
    },
  },
  mounted() {
    this.fetchrndNotification();
    Event.$on("handleCancel", this.canceltrans);
  },
  beforeDestroy() {
    Event.$off("handleCancel", this.canceltrans);
  },
};
</script>

<style></style>
